export const shouldLoad = () => document.querySelector('[data-controller~="slider-navigation"]') !== undefined;
